import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-safety-dashboard-base',
    templateUrl: './safety-dashboard-base.component.html',
    styleUrls: ['./safety-dashboard-base.component.scss'],
    standalone: false // NOSONAR
})
export class SafetyDashboardBaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.info('something')
  }

}
